<template>
  <div class="bindRole" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{$t('LanguageLib.LABEL')}}“{{ titleType }}”{{$t('LanguageLib.ABOUT_STORE')}}</span>
    </div>
    <div class="content">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delStore()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addStore">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-button type="primary" icon="el-icon-s-custom" @click="checkedStore">{{$t('LanguageLib.CHECKED')}}{{selectStoreData.length}}</el-button>
        </div>
        <div class="operationSearch">
          <i @click="drawerOpen" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan1}">&#xe624;</i>
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotalStore }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
          <i v-show="isSearch" @click="clearSearchData" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="StoreListsearchText"
            @keyup.enter.native="searchStoreList"
          >
          </el-input>
        </div>
      </div>
      <div class="domainWarp">
        <DomainTree @isCollapse-treedata="isCollapseTreedataStoreList" @addcheck-treedata="getTreeCheckDataStoreList" :checkDomainId="parentId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
        <div class="tableWarp" :style="styleRightStoreList">
          <div class="tableParent">
            <el-table
              empty-text=" "
              :data="tableDataStore"
              stripe
              @selection-change="selectionChange"
              @sort-change='sortChangeStoreList'
              :default-sort="defaultSort"
              ref="listPowerSupplyTab"
              style="width: auto;"
              v-loading="loading"
              height="100%">
              <el-table-column
                type="selection"
                width="45">
              </el-table-column>
              <el-table-column
                prop="storeCode"
                :label="$t('LanguageLib.SHOP_NUMBER')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start" >
                    <span slot="content" type="storeCode">{{scope.row.storeCode}}</span>
                    <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeCode">{{scope.row.storeCode}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="storeName"
                :label="$t('LanguageLib.STORE_NAME')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start">
                    <span slot="content" type="storeName" v-html="$commonfun.RenderWxName('departmentName', scope.row.storeName)"></span>
                    <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeName" v-html="$commonfun.RenderWxName('departmentName', scope.row.storeName)"></span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="storeType"
                :label="$t('LanguageLib.SHOP_TYPE')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="storeType">{{scope.row.storeType}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeType">{{scope.row.storeType}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                prop="brandName"
                :label="$t('LanguageLib.BRAND')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="brandName">{{scope.row.brandName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="brandName">{{scope.row.brandName}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                prop="parentDomainName"
                :label="$t('LanguageLib.ORGANIZATION2')"
                sortable="custom"
                min-width="250">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <ww-open-data slot="content" v-if="$commonfun.iswx(scope.row.parentDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.parentDomainName.slice(3)"></ww-open-data>
                  <ww-open-data ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" v-if="$commonfun.iswx(scope.row.parentDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.parentDomainName.slice(3)"></ww-open-data>
                  <span slot="content" type="departmentName" v-if="!$commonfun.iswx(scope.row.parentDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.parentDomainName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="departmentName" v-if="!$commonfun.iswx(scope.row.parentDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.parentDomainName}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChangeStoreList"
            @current-change="handleCurrentChangeStoreList"
            :current-page="StoreListcurrentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="StoreListpageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotalStore">
          </el-pagination>
        </div>
      </div>
      <el-drawer
        :visible.sync="drawer"
        :show-close="true"
        :modal="false"
        :wrapperClosable="false"
        size="420px"
        :with-header="false">
        <div style="overflow: hidden">
          <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
          <el-button @click="drawerClose" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
        </div>
        <div class="filterContent" style="padding-right: 10px;">
          <p class="drawerText">{{$t('LanguageLib.SHOP_NUMBER')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="StoreListStoreCode"
          >
          </el-input>
          <p class="drawerText">{{$t('LanguageLib.STORE_NAME')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="StoreListStoreName"
          >
          </el-input>
          <p class="drawerText">{{$t('LanguageLib.SHOP_TYPE')}}</p>
          <el-select multiple filterable v-model="StoreListstoreTypes" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
            <el-option
              v-for="item in storeTypeList"
              :key="item.id"
              :label="item.typeName"
              :value="item.id">
            </el-option>
          </el-select>
          <p class="drawerText">{{$t('LanguageLib.BRAND')}}</p>
          <el-select multiple filterable v-model="StoreListbrandIds" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
            <el-option
              v-for="item in brandInfoList"
              :key="item.id"
              :label="item.brandNameCn"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div style="float: right;margin-top: 10px;">
          <el-button @click="resetSearchData" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
          <el-button @click="searchOrgList" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
        </div>
      </el-drawer>
      <el-dialog style="position: absolute;" :title="$t('LanguageLib.ADD_SHOP')" :visible.sync="dialogAddStore" class="addaboutStoreDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
        <div class="operation">
          <div class="operationBtn">
            <el-button type="primary" icon="el-icon-s-custom" style="margin-left: 0;" @click="checkedAddStore">{{$t('LanguageLib.CHECKED')}}{{selectStoreDataAdd.length}}</el-button>
          </div>
          <div class="operationSearch">
            <i @click="drawerOpenaAdd" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan2}">&#xe624;</i>
            <span v-show="isSearchAdd" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotalAddStore }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
            <i v-show="isSearchAdd" @click="clearSearchDataAdd" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
            <el-input
              placeholder=""
              prefix-icon="el-icon-search"
              v-model="addStoresearchText"
              @keyup.enter.native="searchAddStore"
            >
            </el-input>
          </div>
        </div>
        <div class="domainWarp">
          <DomainTree @isCollapse-treedata="isCollapseTreedataAddStore" @addcheck-treedata="getTreeCheckDataAddStore" :checkDomainId="parentId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
          <div class="tableWarp" :style="styleRightAddStore">
            <div class="tableParent">
              <el-table
                empty-text=" "
                ref="tableList"
                :data="tableDataAddStore"
                stripe
                @selection-change="selectionChangeAddStore"
                @sort-change='sortChangeAddStore'
                style="width: auto;"
                v-loading="loading"
                height="100%">
                <el-table-column
                  type="selection"
                  width="45"
                  :selectable='selectInit'>
                </el-table-column>
                <el-table-column
                  prop="storeCode"
                  :label="$t('LanguageLib.SHOP_NUMBER')"
                  sortable="custom"
                  min-width="100">
                  <template slot-scope="scope">
                    <el-tooltip effect="light" placement="top-start" >
                      <span slot="content" type="storeCode">{{scope.row.storeCode}}</span>
                      <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeCode">{{scope.row.storeCode}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                prop="storeName"
                :label="$t('LanguageLib.STORE_NAME')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start">
                    <span slot="content" type="storeName" v-html="$commonfun.RenderWxName('departmentName', scope.row.storeName)"></span>
                    <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeName" v-html="$commonfun.RenderWxName('departmentName', scope.row.storeName)"></span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="storeType"
                :label="$t('LanguageLib.SHOP_TYPE')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="storeType">{{scope.row.storeType}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeType">{{scope.row.storeType}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                prop="brandName"
                :label="$t('LanguageLib.BRAND')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="brandName">{{scope.row.brandName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="brandName">{{scope.row.brandName}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                prop="parentDomainName"
                :label="$t('LanguageLib.ORGANIZATION2')"
                sortable="custom"
                min-width="250">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <ww-open-data slot="content" v-if="$commonfun.iswx(scope.row.parentDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.parentDomainName.slice(3)"></ww-open-data>
                  <ww-open-data ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" v-if="$commonfun.iswx(scope.row.parentDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.parentDomainName.slice(3)"></ww-open-data>
                  <span slot="content" type="departmentName" v-if="!$commonfun.iswx(scope.row.parentDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.parentDomainName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="departmentName" v-if="!$commonfun.iswx(scope.row.parentDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.parentDomainName}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              </el-table>
            </div>
            <el-pagination
              @size-change="handleSizeChangeAddStore"
              @current-change="handleCurrentChangeAddStore"
              :current-page="addStorecurrentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="addStorepageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotalAddStore">
            </el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
        <el-drawer
          class="addStoreDrawer"
          :visible.sync="drawerAdd"
          :show-close="true"
          :modal="false"
          :wrapperClosable="false"
          size="420px"
          :with-header="false">
          <div style="overflow: hidden">
            <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
            <el-button @click="drawerCloseAdd" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
          </div>
          <div class="filterContent" style="padding-right: 10px;">
              <p class="drawerText">{{$t('LanguageLib.SHOP_NUMBER')}}</p>
              <el-input
                :placeholder="$t('LanguageLib.PleaseEnter')"
                v-model="addStoreStoreCode"
              >
              </el-input>
              <p class="drawerText">{{$t('LanguageLib.STORE_NAME')}}</p>
              <el-input
                :placeholder="$t('LanguageLib.PleaseEnter')"
                v-model="addStoreStoreName"
              >
              </el-input>
              <p class="drawerText">{{$t('LanguageLib.SHOP_TYPE')}}</p>
              <el-select multiple filterable v-model="addStorestoreTypes" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                <el-option
                  v-for="item in storeTypeList"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id">
                </el-option>
              </el-select>
              <p class="drawerText">{{$t('LanguageLib.BRAND')}}</p>
              <el-select multiple filterable v-model="addStorebrandIds" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                <el-option
                  v-for="item in brandInfoList"
                  :key="item.id"
                  :label="item.brandNameCn"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          <div style="float: right;margin-top: 10px;">
            <el-button @click="resetSearchDataAdd" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
            <el-button @click="searchOrgListAdd" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
          </div>
        </el-drawer>
      </el-dialog>
      <!--已选店铺-->
      <el-dialog :title="checkedStoreTitle" :visible.sync="dialogcheckedStore" class="checkedStoreDialog dialogAdd" :before-close="closeCheckedStoreDialog" :close-on-click-modal="false" :modal="false">
          <ul>
            <li v-for="item in checkedStoreData" :key="item.storeId">
              <img v-if="item.storeThumbnail != '' && item.storeThumbnail != null" :src="item.storeThumbnail" @error="imgError(item)"/>
              <img v-if="item.storeThumbnail == '' || item.storeThumbnail == null" src="@/assets/images/storeCover.png"/>
              <el-tooltip effect="light" placement="top-start">
                <!-- <span :title="item.storeName">{{item.storeName}}</span> -->
                <span slot="content" v-html="$commonfun.RenderWxName('departmentName', item.storeName)"></span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="brandName" v-html="$commonfun.RenderWxName('departmentName', item.storeName)"></span>
              </el-tooltip>
            </li>
          </ul>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import storeinformationApi from '../../api/storeinformation'
import DomainTree from '@/components/DomainTree.vue'
export default {
  name: 'AddStore',
  components: { DomainTree },
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    return {
      titleType: this.$route.query.name,
      loading: true, // loading状态
      isSearch: false, // 是否为搜索状态-店铺列表
      isSearchAdd: false, // 是否为搜索状态-添加店铺
      orgTreeData: [], // 组织树数据
      orgData: [], // 组织树源数据
      oneNodeArr: [], // 一级组织下的数据
      drawer: false, // 抽屉框默认收起-店铺列表
      drawerAdd: false, // 抽屉框默认收起-添加店铺
      shaixuan1: false, // 漏斗图是否高亮-店铺列表
      shaixuan2: false, // 漏斗图是否高亮-添加店铺
      delDisabled: true, // 删除按钮默认禁用
      parentIdStoreList: '', // 列表请求parentId-店铺列表
      parentIdAddStore: '', // 列表请求parentId-添加店铺
      styleRightStoreList: 'width: 80%;margin-left: 20%', // right默认宽度-店铺列表
      styleRightAddStore: 'width: 80%;margin-left: 20%', // right默认宽度-添加店铺
      selectStoreData: [], // 选中的组织数据-id
      selectStoreDataAll: [], // 选中的组织数据-item
      selectStoreDataAdd: [], // 选中的要添加的组织数据-id
      selectStoreDataAddAll: [], // 选中的要添加的组织数据-item
      dialogAddStore: false, // 是否显示添加店铺弹框
      dialogcheckedStore: false, // 是否显示已选店铺弹框
      tableDataStore: [], // 列表数据-店铺列表
      pageTotalStore: 0, // 数据总数-店铺列表
      tableDataAddStore: [], // 列表数据-添加店铺
      pageTotalAddStore: 0, // 数据总数-添加店铺
      checkedStoreTitle: '', // 已选店铺弹框标题
      getStoreList: (DomainId, pageIndex, pageSize, sort, IsAsc, StoreTagId, SearchVal, StoreName, StoreCode, storeTypes, brandIds, onlyRelation) => {
        this.loading = true
        if (DomainId === '') {
          DomainId = null
        }
        // 请求列表接口数据
        basicdataApi.relationaUserList('post', '/tag/relationStoreList', { DomainId, pageIndex, pageSize, sort, IsAsc, StoreTagId, SearchVal, StoreName, StoreCode, storeTypes, brandIds, onlyRelation })
          .then(res => {
            this.tableDataStore = res.data.data
            this.pageTotalStore = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数角色列表
      getAddStoreList: (domainId, pageIndex, pageSize, sort, IsAsc, StoreTagId, SearchVal, StoreName, StoreCode, storeTypes, brandIds, onlyRelation) => {
        this.loading = true
        if (domainId === '') {
          domainId = null
        }
        // 请求列表接口数据
        basicdataApi.relationaUserList('post', '/tag/relationStoreList', { domainId, pageIndex, pageSize, sort, IsAsc, StoreTagId, SearchVal, StoreName, StoreCode, storeTypes, brandIds, onlyRelation })
          .then(res => {
            this.tableDataAddStore = res.data.data
            this.pageTotalAddStore = res.data.total
            this.loading = false
            this.$nextTick(() => {
              this.tableDataAddStore.forEach((row, index) => {
                if (row.isRelation) {
                  this.$refs.tableList.toggleRowSelection(this.tableDataAddStore[index])
                  this.selectStoreDataAdd = []
                  this.selectStoreDataAddAll = []
                }
              })
            })
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数-添加角色
      defaultSort: { prop: 'storeCode', order: 'ascending' }, // 默认显示排序
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'storeCode', // 记录前一次的prop值
      prevSort1: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp1: 'storeCode', // 记录前一次的prop值
      StoreListcurrentPage: 1, // 默认显示第1页数据-店铺列表
      StoreListpageSize: 20, // 默认每页显示20条数据-店铺列表
      StoreListsort: 2, // 0：新增时间 1：店铺名称 2：店铺编号 3：店铺类型 4：品牌 5：上级组织
      StoreListIsAsc: true, // 排序方式逆序：desc正序asc -店铺列表
      StoreListsearchText: '', // 模糊搜索 -店铺列表
      StoreListStoreName: '', // 店铺名称 -店铺列表
      StoreListStoreCode: '', // 店铺编号 -店铺列表
      StoreListstoreTypes: [], // 店铺类型 -店铺列表
      StoreListbrandIds: [], // 所属品牌-店铺列表
      id: this.$route.query.id, // 店铺标签id
      addStorecurrentPage: 1, // 默认显示第1页数据-添加店铺
      addStorepageSize: 20, // 默认每页显示20条数据-添加店铺
      addStoresort: 0, // 排序字段 0：添加时间 1：角色名称 2：组织类型 3：用户类型 -添加店铺
      addStoreIsAsc: true, // 排序方式逆序：desc正序asc -添加店铺
      addStoresearchText: '', // 模糊搜索 -添加店铺
      addStoreStoreName: '', // 店铺名称 -添加店铺
      addStoreStoreCode: '', // 店铺编号 -添加店铺
      addStorestoreTypes: [], // 店铺类型 -添加店铺
      addStorebrandIds: [], // 所属品牌-店铺列表
      loadingSave: false, // 保存按钮加loding
      storeTypeList: [], // 店铺类型列表
      brandInfoList: [], // 所属品牌列表
      checkedStoreData: [] // 已选择的店铺数据列表
    }
  },
  created () {
    // 获取组织树列表
    basicdataApi.gettreelist('get', '/sysdomain/domainTree')
      .then(res => {
        this.orgData = res.data
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
  },
  methods: {
    // 返回
    goReturn () {
      this.$router.push('/basicdata/tagmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&currentType=' + this.$route.query.currentType)
    },
    imgError (item) {
      item.storeThumbnail = ''
    },
    // 已添加过的店铺不允许被勾选
    selectInit (row, index) {
      if (row.isRelation) {
        return false // 不可勾选
      } else {
        return true // 可勾选
      }
    },
    // 列表排序-店铺列表
    sortChangeStoreList (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.StoreListIsAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.StoreListIsAsc = false
          this.prevSort = 'descending'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.listPowerSupplyTab.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.StoreListIsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'storeCode':
          this.StoreListsort = 2
          break
        case 'storeName':
          this.StoreListsort = 1
          break
        case 'storeType':
          this.StoreListsort = 3
          break
        case 'brandName':
          this.StoreListsort = 4
          break
        case 'parentDomainName':
          this.StoreListsort = 5
          break
      }
      // 请求列表接口数据
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 页数改变-店铺列表
    handleSizeChangeStoreList (val) {
      this.StoreListpageSize = val
      // 请求列表接口数据
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 每页条数改变-店铺列表
    handleCurrentChangeStoreList (val) {
      this.StoreListcurrentPage = val
      // 请求列表接口数据
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 列表模糊搜索-店铺列表
    searchStoreList () {
      this.StoreListcurrentPage = 1
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 显示隐藏组织树-店铺列表
    isCollapseTreedataStoreList (data) {
      if (data === true) {
        this.styleRightStoreList = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRightStoreList = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 树组件传过来的数据-店铺列表
    getTreeCheckDataStoreList (data) {
      this.parentIdStoreList = data.id
      // 请求列表接口数据
      this.StoreListcurrentPage = 1
      this.StoreListpageSize = 20
      //    this.updataRouteQuery()
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 过滤点击-店铺列表
    drawerOpen () {
      this.drawer = true
      this.shaixuan1 = true
      // 获取店铺类型列表
      storeinformationApi.GetStoreType('get', '/store/GetStoreType')
        .then(res => {
          this.storeTypeList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
      // 获取所属品牌列表
      storeinformationApi.GetBrandInfo('get', '/store/GetBrandInfo')
        .then(res => {
          this.brandInfoList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 过滤关闭-店铺列表
    drawerClose () {
      this.drawer = false
      this.shaixuan1 = false
    },
    // 点击搜索-店铺列表
    searchOrgList () {
      this.drawer = false
      this.isSearch = true
      this.StoreListcurrentPage = 1
      // this.updataRouteQuery()
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 清空搜索数据-店铺列表
    resetSearchData () {
      this.StoreListStoreName = ''
      this.StoreListStoreCode = ''
      this.StoreListstoreTypes = []
      this.StoreListbrandIds = []
    },
    // 清除搜索状态-店铺列表
    clearSearchData () {
      this.shaixuan1 = false
      this.isSearch = false
      this.StoreListStoreName = ''
      this.StoreListStoreCode = ''
      this.StoreListstoreTypes = []
      this.StoreListbrandIds = []
      this.StoreListcurrentPage = 1
      //    this.updataRouteQuery()
      this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
    },
    // 删除绑定店铺数据
    delStore () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.delRelationaStore('post', '/tag/delRelationStore', {
            storeTagId: this.$route.query.id,
            storeIds: this.selectStoreData
          })
            .then(res => {
              this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 选择要删除的店铺
    selectionChange (selection) {
      this.selectStoreData = []
      this.selectStoreDataAll = []
      for (let i = 0; i < selection.length; i++) {
        this.selectStoreData.push(selection[i].storeId)
        this.selectStoreDataAll.push(selection[i])
      }
      if (this.selectStoreData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 打开已选店铺-店铺列表
    checkedStore () {
      this.dialogcheckedStore = true
      this.checkedStoreTitle = this.$t('LanguageLib.CHECKED_STORE') + this.selectStoreDataAll.length
      this.checkedStoreData = this.selectStoreDataAll
    },
    // 关闭已选店铺对话框
    closeCheckedStoreDialog () {
      this.dialogcheckedStore = false
    },
    // 添加店铺数据
    addStore () {
      this.dialogAddStore = true
      this.shaixuan2 = false
      this.isSearchAdd = false
      this.addStoreStoreName = ''
      this.addStoreStoreCode = ''
      this.addStorestoreTypes = []
      this.addStorebrandIds = []
      this.addStorecurrentPage = 1
      this.addStorepageSize = 20
      this.addStoresort = 0
      this.addStoreIsAsc = true
      this.addStoresearchText = ''
      this.selectStoreDataAdd = []
      this.selectStoreDataAddAll = []
      this.$nextTick(() => {
        this.$refs.tableList.clearSort()
      })
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 显示隐藏组织树-添加店铺
    isCollapseTreedataAddStore (data) {
      if (data === true) {
        this.styleRightAddStore = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRightAddStore = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 树组件传过来的数据-添加店铺
    getTreeCheckDataAddStore (data) {
      this.parentIdAddStore = data.id
      // 请求列表接口数据
      this.addStorecurrentPage = 1
      this.addStorepageSize = 20
      //    this.updataRouteQuery()
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 过滤点击-添加店铺
    drawerOpenaAdd () {
      this.drawerAdd = true
      this.shaixuan2 = true
      // 获取店铺类型列表
      storeinformationApi.GetStoreType('get', '/store/GetStoreType')
        .then(res => {
          this.storeTypeList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
      // 获取所属品牌列表
      storeinformationApi.GetBrandInfo('get', '/store/GetBrandInfo')
        .then(res => {
          this.brandInfoList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 过滤关闭-添加店铺
    drawerCloseAdd () {
      this.drawerAdd = false
      this.shaixuan2 = false
    },
    // 点击搜索-添加店铺
    searchOrgListAdd () {
      this.drawerAdd = false
      this.isSearchAdd = true
      this.addStorecurrentPage = 1
      // this.updataRouteQuery()
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 清空搜索数据-添加店铺
    resetSearchDataAdd () {
      this.addStoreStoreName = ''
      this.addStoreStoreCode = ''
      this.addStorestoreTypes = []
      this.addStorebrandIds = []
    },
    // 清除搜索状态-添加店铺
    clearSearchDataAdd () {
      this.drawerAdd = false
      this.shaixuan2 = false
      this.isSearchAdd = false
      this.addStoreStoreName = ''
      this.addStoreStoreCode = ''
      this.addStorestoreTypes = []
      this.addStorebrandIds = []
      this.addStorecurrentPage = 1
      //    this.updataRouteQuery()
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 列表排序 -添加店铺
    sortChangeAddStore (column) {
      if (column.order !== null) {
        this.prevSort1 = column.order
        if (column.order === 'ascending') {
          this.addStoreIsAsc = true
          this.prevSort1 = 'ascending'
        } else if (column.order === 'descending') {
          this.addStoreIsAsc = false
          this.prevSort1 = 'descending'
        }
        if (this.prevProp1 !== column.prop) {
          var columns = this.$refs.tableList.columns.find(item => item.property === this.prevProp1)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort1 === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort1 === 'descending' ? 'ascending' : 'descending'
        this.prevProp1 = column.prop
        this.prevSort1 = column.column.order
        this.addStoreIsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'storeCode':
          this.addStoresort = 2
          break
        case 'storeName':
          this.addStoresort = 1
          break
        case 'storeType':
          this.addStoresort = 3
          break
        case 'brandName':
          this.addStoresort = 4
          break
        case 'parentDomainName':
          this.addStoresort = 5
          break
      }
      // 请求列表接口数据
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 页数改变 -添加店铺
    handleSizeChangeAddStore (val) {
      this.addStorepageSize = val
      // 请求列表接口数据
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 每页条数改变 -添加店铺
    handleCurrentChangeAddStore (val) {
      this.addStorecurrentPage = val
      // 请求列表接口数据
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 列表模糊搜索 -添加店铺
    searchAddStore () {
      this.addStorecurrentPage = 1
      this.getAddStoreList(this.parentIdAddStore, this.addStorecurrentPage, this.addStorepageSize, this.addStoresort, this.addStoreIsAsc, this.id, this.addStoresearchText, this.addStoreStoreName, this.addStoreStoreCode, this.addStorestoreTypes, this.addStorebrandIds, false)
    },
    // 选择要添加的店铺
    selectionChangeAddStore (selection) {
      this.selectStoreDataAdd = []
      this.selectStoreDataAddAll = []
      for (let i = 0; i < selection.length; i++) {
        this.selectStoreDataAdd.push(selection[i].storeId)
        this.selectStoreDataAddAll.push(selection[i])
      }
    },
    // 已选店铺 -添加店铺
    checkedAddStore () {
      this.dialogcheckedStore = true
      this.checkedStoreTitle = this.$t('LanguageLib.CHECKED_STORE') + this.selectStoreDataAddAll.length
      this.checkedStoreData = this.selectStoreDataAddAll
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.drawerAdd = false
      this.dialogAddStore = false
    },
    // 添加店铺
    submit () {
      if (this.selectStoreDataAdd.length === 0) {
        this.dialogAddStore = false
      } else {
        this.loadingSave = true
        basicdataApi.CreateRelationaStore('post', '/tag/addRelationStore', {
          storeTagId: this.$route.query.id,
          storeIds: this.selectStoreDataAdd
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
            })
            this.dialogAddStore = false
            this.getStoreList(this.parentIdStoreList, this.StoreListcurrentPage, this.StoreListpageSize, this.StoreListsort, this.StoreListIsAsc, this.id, this.StoreListsearchText, this.StoreListStoreName, this.StoreListStoreCode, this.StoreListstoreTypes, this.StoreListbrandIds, true)
            this.loadingSave = false
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      }
    }
  }
}
</script>

<style lang="scss">
  .bindRole {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    // 抽屉组件样式修改
    .el-drawer.rtl{
      outline: none;
    }
    .el-drawer__wrapper{
      top: 233px;
      bottom: 35px;
      /*right: 20px;*/
    }
    .addStoreDrawer{
      top: 110px;
      bottom: 0;
      right: 0;
      position: absolute;
    }
    section.el-drawer__body{
      padding: 20px;
      .el-input{
        margin-bottom: 15px;
      }
    }
    .el-drawer__container{
      outline: none;
    }
    .drawerTitle{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:25px;
      margin-bottom: 20px;
    }
    .drawerText{
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
      margin-bottom: 5px;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px 20px 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .operation{
        background: #fff;
        padding: 0;
        overflow: hidden;
        .operationBtn{
          width: auto;
          display: inline-block;
          float:left;
          position: relative;
          .el-button{
            height: 30px;
            padding: 7px 20px;
          }
        }
        .operationSearch{
          float:right;
          position: relative;
          .shaixuan{
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }
          .shaixuan1{
            color: #3BC6B9;
          }
          .el-input{
            width: 160px;
            .el-input__inner{
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }
          .el-icon-search{
            line-height: 30px;
          }
        }
      }
      .tableWarp{
        border: 1px solid #E1E1E1;
        height: 100%;
        width: 80%;
        margin-left: 20%;
      }
      .domainWarp{
        height: calc(100% - 47px);
        .left{
          background: #fff;
          width: 20%;
          float:left;
          height: calc(100% - 0px);
          border-right: 1px solid #E1E1E1;
          border-bottom: 1px solid #E1E1E1;
          .treeBox{
            height: calc( 100% - 51px );
            overflow: auto;
            width: 100%;
          }
          .fifter{
            padding: 10px 0 10px 6%;
            line-height: 30px;
          .el-input{
              width: 60%;
            }
            .el-button--text{
              margin-left: 2.5%;
              padding: 2% 0;
              width: 20%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      // 对于树组件配置特有的css
      .el-tree-node>.el-tree-node__children{
        overflow: unset;
      }
      .el-tree-node__content{
        height: 48px;
      }
      .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background-color: #F6F6F6;
      }
      // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
      //   color: #3BC6B9 !important;
      // }
      // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
      //   color: #3BC6B9 !important;
      // }
      .tableParent{
        height: calc( 100% - 48px );
      }
      .el-pagination{
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
      .el-button--primary{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
        margin-left: 10px;
      }
      .el-button--primary:hover{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
      }
      /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #3BC6B9 !important;
        border-color: #3BC6B9 !important;
      }*/
      // 更改表格的滚动条样式
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
          width: 10px;
          height: 10px;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #fff;
      }
      .colorG{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(59,198,185,1);
        line-height:20px;
      }
      .el-table .descending .sort-caret.descending{
        border-top-color: #3BC6B9;
      }
      .el-table .ascending .sort-caret.ascending{
        border-bottom-color: #3BC6B9;
      }
      .el-pager li.active{
        color: #3BC6B9;
      }
      .el-table__fixed-body-wrapper .el-table__body{
          padding-bottom: 10px;
      }
      .el-table-column--selection{
        text-align: center !important;
      }
      .el-tooltip__popper.is-dark{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        border: 1px solid #E4E7ED !important;
        background-color: #fff;
        color: #000;
        .popper__arrow{
          border-top-color: #E4E7ED;
        }
        .popper__arrow::after{
          border-top-color: #fff;
        }
      }
      .el-table__fixed-right{
        height: 100% !important;
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
    .el-table__header{
      width: calc(100% + 17px) !important;
    }
    .el-table__body{
      width: calc(100% + 7px) !important;
    }
  }
  .uploadParent{
    .el-button--primary{
      margin-bottom: 0;
    }
    .el-upload__tip{
      margin-top: 10px;
    }
  }
.checkedStoreDialog{
  .el-dialog{
    height: calc(100% - 170px);
    width: 420px !important;
    .el-dialog__header{
      padding-top: 20px;
      .el-dialog__headerbtn{
        top: 24px;
      }
    }
    .el-dialog__body{
      padding-top: 10px;
      height: calc(100% - 84px);
      overflow-y: auto;
      ul{
        list-style: none;
        overflow: hidden;
        li{
          float: left;
          width: 20%;
          text-align: center;
          margin-bottom: 20px;
          img{
            width: 80%;
            border-radius: 50%;
            border: 1px solid #E1E1E1;
          }
          span{
            display: block;
            width: calc(100% - 20px);
            padding: 0 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .el-dialog__body::-webkit-scrollbar{
        width: 10px;
        height: 10px;
    }
    .el-dialog__body::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .el-dialog__body::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }
  }
}
.addaboutStoreDialog{
  .el-dialog{
    height: calc(100% - 170px);
    width: 1000px !important;
    .el-dialog__body{
      padding-top: 0;
      padding-bottom: 0;
      height: calc(100% - 130px);
      .operationSearch{
        overflow: hidden;
        margin-bottom: 10px;
        line-height: 30px;
        .shaixuan{
          color: #999999;
          height: 15px;
          width: 15px;
          position: relative;
          top: 2px;
          margin-left: 10px;
          margin-right: 10px;
          font-weight: 600;
        }
        .shaixuan1{
          color: #3BC6B9;
        }
        .el-input{
          width: 160px;
          float: right;
          .el-input__inner{
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }
        .el-icon-search{
          line-height: 30px;
        }
      }
      .tableParent{
        height: calc(100% - 48px);
      }
    }
    .el-dialog__footer{
      padding: 25px 20px 20px;
    }
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
</style>
